import React from "react";
import * as styles from "./CopyRightFooter.module.scss";
import { Link, TypographyV2 } from "@components";
import moment from "moment";
import { StaticImage } from "gatsby-plugin-image";
import { LINKS } from "@components/Link/Link";

type FooterProps = {
	theme: "light" | "dark";
};

export default function CopyRightFooter({ theme }: FooterProps) {
	return (
		<div
			className={`${
				theme === "dark"
					? styles.copyRightFooterContainerDark
					: styles.copyRightFooterContainerLight
			}`}
		>
			<div className={styles.socials}>
				{theme === "dark" ? (
					<StaticImage src="../img/logodark.png" alt="genemod_Logo" />
				) : (
					<StaticImage src="../../Header/img/Logo.png" alt="genemod_Logo" />
				)}
			</div>
			<div className={styles.policyContainer}>
				<TypographyV2
					className={`${
						theme === "dark"
							? styles.copyrightDark
							: styles.copyrightLight
					}`}
				>
					{`© ${moment().format("yyyy")} Genemod, Inc.`}{" "}
				</TypographyV2>
				<div className={styles.linksContainer}>
					{(
						[
							"PRIVACY_POLICY",
							"TERMS_OF_SERVICE",
							"MSA",
							"DPA",
						] as const
					).map((link, i) => (
						<Link link={link} key={i}>
							<TypographyV2
								className={`${
									theme === "dark"
										? styles.linkDark
										: styles.linkLight
								}`}
							>
								{LINKS[link].title}
							</TypographyV2>
						</Link>
					))}
				</div>
			</div>
		</div>
	);
}

function Certifications() {
	return (
		<div className={styles.certifications}>
			<StaticImage
				loading="eager"
				src="../../../assets/icons/badge-CCPA.png"
				alt="CCPA badge"
				height={52}
			/>
			<StaticImage
				loading="eager"
				src="../../../assets/icons/badge-GDPR.png"
				alt="GDPR badge"
				height={52}
			/>
			<StaticImage
				loading="eager"
				src="../../../assets/icons/badge-CFR.png"
				alt="CFR badge"
				height={40}
			/>
			<StaticImage
				loading="eager"
				src="../../../assets/icons/badge-SOC2.png"
				alt="SOC2 badge"
				height={52}
			/>
		</div>
	);
}
